
import { Link } from 'react-router-dom';

interface RetreatCardProps {
  retreat: {
    id: number;
    name: string;
    location: string;
    price: string;
    rating: number;
    reviews: number;
    image: string;
    features: string[];
    type: string;
    description: string;
  };
}

export default function RetreatCard({ retreat }: RetreatCardProps) {
  return (
    <div className="bg-white rounded-2xl shadow-lg overflow-hidden hover:shadow-xl transition-shadow duration-300 group">
      <div className="relative h-64 overflow-hidden">
        <img 
          src={retreat.image} 
          alt={retreat.name}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
        />
        <div className="absolute top-4 left-4 bg-emerald-600 text-white px-3 py-1 rounded-full text-sm font-medium">
          {retreat.type}
        </div>
        <div className="absolute top-4 right-4 bg-white/90 backdrop-blur-sm rounded-full p-2 cursor-pointer hover:bg-white transition-colors">
          <i className="ri-heart-line text-gray-700 text-lg"></i>
        </div>
      </div>
      
      <div className="p-6">
        <div className="flex items-center justify-between mb-2">
          <h3 className="text-xl font-bold text-gray-900">{retreat.name}</h3>
          <div className="flex items-center space-x-1">
            <i className="ri-star-fill text-yellow-400 text-sm"></i>
            <span className="text-sm font-medium text-gray-700">{retreat.rating}</span>
          </div>
        </div>
        
        <div className="flex items-center text-gray-600 mb-3">
          <i className="ri-map-pin-line text-emerald-600 mr-2"></i>
          <span className="text-sm">{retreat.location}</span>
        </div>

        <p className="text-gray-600 text-sm mb-4 line-clamp-2">{retreat.description}</p>

        <div className="flex flex-wrap gap-2 mb-4">
          {retreat.features.slice(0, 3).map((feature, index) => (
            <span key={index} className="bg-gray-100 text-gray-700 px-3 py-1 rounded-full text-xs font-medium">
              {feature}
            </span>
          ))}
          {retreat.features.length > 3 && (
            <span className="bg-gray-100 text-gray-600 px-3 py-1 rounded-full text-xs">
              +{retreat.features.length - 3} more
            </span>
          )}
        </div>

        <div className="flex items-center justify-between">
          <div>
            <span className="text-2xl font-bold text-gray-900">{retreat.price}</span>
            <span className="text-gray-600 text-sm">/night</span>
            <div className="text-xs text-gray-500">{retreat.reviews} reviews</div>
          </div>
          <Link 
            to="/book"
            className="bg-emerald-600 text-white px-6 py-2 rounded-lg font-semibold hover:bg-emerald-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            Book Now
          </Link>
        </div>
      </div>
    </div>
  );
}